/** @format */
import { css } from 'styled-components';

import { theme } from '@toucan/config/theme';

import { smallMobile, smallTablet } from '@toucan/helpers/media-queries';

import { TabProps, TabVariant } from './index';

const baseStyles = () => css`
    display: inline-block;
    text-align: center;
    background: none;
    border: 0;
    cursor: pointer;
`;

const activeStyles = ({ active, variant }: TabProps) => {
    if (!active) {
        return css``;
    }

    switch (variant) {
        case TabVariant.INFO:
            return css`
                &,
                &:hover {
                    background: var(--colors-surface-accent-inverse);
                    ${theme.typography.body_normal_highlight};
                }
            `;
        default:
            return css`
                opacity: 1;
                border-bottom: 2px solid var(--colors-border-interactive);

                &:hover {
                    opacity: 1;
                }
            `;
    }
};

const disabledStyles = ({ disabled, variant }: TabProps) => {
    if (!disabled) {
        return css``;
    }

    switch (variant) {
        case TabVariant.INFO:
            return css`
                &,
                &:hover {
                    background: unset;
                    color: var(--colors-text-disabled);
                }
            `;
        default:
            return css`
                opacity: 1;
                color: var(--colors-text-primary);
                border: 0;

                &:hover {
                    opacity: 1;
                }
            `;
    }
};

const variantStyles = ({ variant }: TabProps) => {
    switch (variant) {
        case TabVariant.INFO:
            return css`
                padding: var(--layout-spacing-16);
                min-width: 16rem;
                border-radius: 0.8rem;
                ${theme.typography.body_normal};
                color: var(--colors-text-inverse);

                &:hover {
                    background: rgba(255, 255, 255, 0.15);
                }

                ${smallTablet(css`
                    min-width: 12rem;
                `)}

                ${smallMobile(css`
                    min-width: 11rem;
                    padding: var(--layout-spacing-12);
                `)}
            `;
        default:
            return css`
                text-transform: uppercase;
                text-decoration: none;
                font-size: 1.2rem;
                font-weight: 300;
                padding: 1.5rem 0;
                letter-spacing: 0.2rem;
                color: var(--colors-text-secondary);
                opacity: 0.6;

                &:hover {
                    opacity: 0.8;
                }
            `;
    }
};

export const styles = (props: TabProps) => css`
    ${baseStyles()}
    ${variantStyles(props)}
    ${activeStyles(props)}
    ${disabledStyles(props)}
`;
